import { Button, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import Iconify from '../../../reusable-components/iconify';
import useNavigationDisabledMessage from './useNavigationDisabledMessage';

BackToHomeButton.propTypes = {
  isAddingFac: PropTypes.bool,
};

export default function BackToHomeButton({ isAddingFac = false }) {
  const navigate = useNavigate();
  const disabledMessage = useNavigationDisabledMessage(isAddingFac);

  return (
    <Tooltip
      placement="left"
      arrow
      title={disabledMessage}
      sx={{ fontSize: '1rem' }}
      disableHoverListener={!disabledMessage}
    >
      <span>
        <Button
          sx={{ py: 0 }}
          onClick={() => {
            navigate('/dashboard/transitions/home');
          }}
          disabled={!!disabledMessage}
        >
          <Iconify icon="mdi:chevron-left" /> Back to home
        </Button>
      </span>
    </Tooltip>
  );
}
